import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import {
  clickTracker,
  getContractTypeVal,
  getProjectId,
  hasJdMartVertical,
  env,
  getCookie,
  ticketFiltersObj,
  trackUserType,
} from '../lib/common';
import MyTickets from '../components/Home/MyTickets';
import FaqWrapper from '../components/common/FaqWrapper';
import styles from '../styles/Tickets.module.scss';
import { useAuth } from '../contexts/auth';
import NoDataView from './NoDataView';
import { getClickTrackersInfo } from '../api';

function TicketsList() {
  const projectId = getProjectId();
  const {
    getTicketsData,
    myTicketsLoading,
    loader,
    setLoader,
    setPage,
    setChangeTicket,
    selectedStatus,
    setSelectedStatus,
    ticketId,
    setTicketId,
    myTicketsData,
    datesResp,
  } = useOutletContext();

  const statusesList = ['All', 'Open', 'In Progress', 'Closed', 'Grievance Redressal'];

  const [statuses] = useState(statusesList);
  const [hideViewAll] = useState(true);
  const contractType = getContractTypeVal(projectId);

  if (projectId === 'genio' || contractType === 'user') {
    statusesList.pop();
  }

  const selectedBusiness = JSON.parse(localStorage.getItem('selectedBusiness'));
  const [authState] = useAuth();
  const { userDetails } = authState;

  const reloadMyTickets = async () => {
    try {
      await getTicketsData(selectedStatus, true);
    } catch (e) {
      console.error('Error fetching tickets while reloading', e);
    }
  };

  const handleStatus = async (item) => {
    setLoader(true);
    setSelectedStatus(item);
    setChangeTicket(true);
    setTicketId('');
    getTicketsData(item, true, true);
    if (projectId === 'genio') {
      await clickTracker(ticketFiltersObj?.[item], 'geniocs_mytickets');
    } else if (trackUserType?.[contractType]) {
      await clickTracker(
        ticketFiltersObj?.[item],
        contractType === 'user' ? 'User_Mytickets_page' : `${trackUserType?.[contractType]}_mytickets_page`,
      );
    }
  };

  const handleOnLanding = async (liVal = '', liTrd = '', faqTypeVal = '', othersData = []) => {
    try {
      let sessionId = getCookie('session_id');
      if (!sessionId) {
        sessionStorage.setItem('session_id', sessionId);
      }
      if (!sessionId) {
        sessionId = Math.random().toString(36).slice(2);
        document.cookie = `session_id=${sessionId}; path=/;`;
        sessionStorage.setItem('session_id', sessionId);
      }
      if (sessionId) {
        const jduId = userDetails?.jduid || '';
        const sectionOthersData = othersData?.map((item) => item.title);

        const trdObj = {
          cname: selectedBusiness?.compname || '',
          cta_name: '',
          docid: selectedBusiness?.docid || '',
          city: selectedBusiness?.city || '',
          dcity: selectedBusiness?.data_city || '',
          area: selectedBusiness?.areaname || '',
          pin: selectedBusiness?.pincode || '',
          ds: '',
          pdg: '',
          paid: selectedBusiness?.paidstatus || '',
          usertype: authState?.sidResponse ? `${trackUserType?.[contractType]}` : 'non_login',
          jd_verified: '',
          guarantee: '',
          trust: '',
          verified: '',
          tag: '',
          pos: '',
          li: liTrd,
          sections: [],
        };
        if (liTrd === 'landing') {
          trdObj.sections = [];
          trdObj.cta_name = ['Chat with Us', 'Get a Callback'];
        }
        if (liVal === 'click') {
          trdObj.sections = faqTypeVal === 'Others' ? sectionOthersData : '';
          trdObj.cta_name = '';
        }
        // API Params
        const paramsData = {
          session_id: sessionId,
          search_id: sessionId,
          trd: [trdObj],
          li: liVal,
          ll: 'cshmpg',
          referrer: 'auto',
          user_ip: '',
          city: selectedBusiness?.city || '',
          data_city: selectedBusiness?.data_city || '',
          area: selectedBusiness?.areaname || '',
          pincode: selectedBusiness?.pincode || '',
          jduid: jduId || '',
          mobile: userDetails?.mobile || '',
          request_time: '',
          device_src: getCookie('device_src') || '2',
          device_id: '',
          category_name: '',
          user_agent: '',
          sid: getCookie('sid') || '',
          jde: '',
          vid: '615',
          env,
          utm_source: '',
          utm_medium: '',
          utm_campaign: '',
          app_version: '',
          transaction_id: '',
        };
        await getClickTrackersInfo(paramsData);
      }
    } catch (err) {
      console.log('Error in handleClickTrackers', err);
    }
  };

  const hasNoAccess =
    projectId === 'csportal'
      ? (!authState?.sidResponse && !selectedBusiness?.docid) ||
        (selectedBusiness?.docid && contractType === 'free' && !hasJdMartVertical())
      : false;
  return (
    <div>
      {hasNoAccess ? (
        <NoDataView pageName="My Tickets" />
      ) : (
        <>
          {loader ? (
            <div className="loader-container">
              <div className="bt-spinner" />
            </div>
          ) : (
            <div className={`${styles.Ticket} p-20 pt-0`}>
              <div style={{ overflow: 'auto', whiteSpace: 'nowrap', color: 'white', paddingBottom: '1em' }}>
                <ul className="mt-20">
                  {statuses &&
                    statuses.map((item, idx) => (
                      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
                      <li
                        className={`${styles.Ticket__FilterItem} ${
                          item === selectedStatus ? styles.Ticket__FilterItem__Active : ''
                        } font12 fw500`}
                        key={idx}
                        onClick={() => {
                          setPage(1);
                          handleStatus(item);
                        }}
                      >
                        {item}
                      </li>
                    ))}
                </ul>
              </div>
              {/* <div>
            {myTicketsData.length > 0 && (
              <div className="font13 fw500 color111 mt-20 text-center">
                Here are all the tickets that were raised by you.
              </div>
            )}
          </div> */}
              {datesResp?.startDate && (
                <div className="mt-20 pl-20 pr-20" style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <div className="font14 fw600 color111" style={{ marginRight: '3px' }}>
                    Selected Date range:{' '}
                  </div>
                  <span className="font12 fw500 color777" style={{ marginTop: '3px' }}>
                    {datesResp?.startDate}- {datesResp?.endDate}
                  </span>
                </div>
              )}

              <div
                className={`${styles.Accordion__Search}`}
                style={{ float: 'right', marginTop: '15px', marginBottom: '15px' }}
              >
                <input
                  className={`${styles.Accordion__Input} font12 fw500 color111`}
                  type="text"
                  placeholder={`Search by ${projectId === 'genio' ? 'Ticket Id/Company name' : 'Ticket Id'}...`}
                  value={ticketId}
                  onChange={(e) => {
                    setChangeTicket(true);
                    setTicketId(e.target.value);
                    setPage(0);
                  }}
                />
              </div>

              <MyTickets
                reloadMyTickets={reloadMyTickets}
                loading={myTicketsLoading}
                myTicketsData={myTicketsData}
                hideViewAll={hideViewAll}
                id="mytickets_page"
                handleOnLanding={handleOnLanding}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
export default FaqWrapper(TicketsList);
